// components/CustomScriptInjector/index.tsx — CustomScriptInjector composition
import React from 'react';
import type { Form } from '../../types';
import { useCustomScriptInjection } from './hooks';

interface CustomScriptInjectorProps {
    form?: Form;
    location?: 'formPage' | 'thankYouPage';
    scriptContent?: string;
    brandId?: string;
    /** Kunci dedupe konversi Ads lead (mis. orderId) — sekali per sesi. */
    dedupeKey?: string;
}

const CustomScriptInjector: React.FC<CustomScriptInjectorProps> = ({ form, location, scriptContent, brandId, dedupeKey }) => {
    useCustomScriptInjection(form, location, scriptContent, brandId, dedupeKey);

    return null;
};

export default CustomScriptInjector;
